<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <edit-business-form
          :create-mode="false"
          data-background-color="secondary"
          :show-add-employee="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EditBusinessForm from "@/views/Forms/EditBusinessForm";

export default {
  components: {
    EditBusinessForm
  }
};
</script>

<style scoped></style>
